<template>
  <div ref="htmxRoot" v-once>
    <span>Loading…</span>
  </div>
</template>

<script>
export default {
  name: "HtmxPartial",
  props: {
    url: { type: String, required: true } // e.g. '/partials/thing'
  },
  mounted() {
    this._authHandler = (evt) => {
      const token = this.$store?.state?.AuthModule?.token;
      if (token) {
        evt.detail.headers['Authorization'] = `Bearer ${token}`;
      }
    };
    document.body.addEventListener('htmx:configRequest', this._authHandler);
    if (this._tokenValid()) {
      this.load();
    } else {
      this.$store.dispatch('AuthModule/logout');
    }
  },
  watch: {
    url(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.load();
      }
    },
  },
  methods: {
    _tokenValid() {
      const token = this.$store?.state?.AuthModule?.token;
      if (!token) return false;
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp && payload.exp * 1000 > Date.now();
      } catch {
        return false;
      }
    },
    load() {
      htmx.ajax('GET', this.url, {
        target: this.$refs.htmxRoot,
        swap: 'innerHTML',
      })
    },
  },
  beforeDestroy() {
    document.body.removeEventListener('htmx:configRequest', this._authHandler);
    // abort any in-flight request if the component is torn down mid-fetch
    const el = this.$refs.htmxRoot
    if (el) {
      const internalData = htmx._('getInternalData', el)
      if (internalData?.xhr) {
        internalData.xhr.abort()
      }
    }
  },
}
</script>
